import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import LoadingState from '../components/LoadingState'

const RequestAccessIndex = lazy(() => import('../pages/pages/RequestAccessIndex'))

export default [
  {
    path: '/request-access',
    element: (
      <DashboardLayout>
        <Suspense fallback={<LoadingState align="center" />}>
          <RequestAccessIndex />
        </Suspense>
      </DashboardLayout>
    )
  }
]
